// extracted by mini-css-extract-plugin
module.exports = {"container":"Vl","timeTop":"Wl","timeCountdown":"Xl","cta":"Yl","disabled":"Zl","product":"_l"};